import { Component, OnInit, inject } from '@angular/core';
import { OrderSummaryComponent as UdxB2bOrderSummaryComponent, AppliedCouponsComponent } from '@spartacus/cart/base/components';
import { BaseSiteService, FeatureLevelDirective, TranslatePipe } from '@spartacus/core';
import { take } from 'rxjs';
import { multiTaxEnabled, USJB2BPortalConfig } from 'src/app/udxb2b/shared/constant/storefront-config';

@Component({
    selector: 'cx-order-summary',
    templateUrl: './order-summary.component.html',
    imports: [
        FeatureLevelDirective,
        AppliedCouponsComponent,
        TranslatePipe,
    ],
})
export class OrderSummaryComponent extends UdxB2bOrderSummaryComponent implements OnInit {
  baseSite = inject(BaseSiteService);
  multiTaxEnabled = false;
  ushSite = false;
  usjfeature = false;
  override ngOnInit(): void {
    super.ngOnInit();

    this.baseSite
      .getActive()
      .pipe(take(1))
      .subscribe((site) => {
        console.log(site);
        if (site === 'b2bportal_ush') {
          this.ushSite = true;
        }

        multiTaxEnabled
          .filter((config) => config.baseSiteId === site)
          .map((config) => {
            this.multiTaxEnabled = config.active;
          });

        USJB2BPortalConfig.filter((config) => config.baseSiteId === site).map((config) => {
          this.usjfeature = config.active;
        });
      });
  }
}
